export default (theme) => ({
    '@global': {
        html: {
            height: '100%'
        },
        body: {
            margin: 0,
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',

            '& > #app, & > #app > *': {
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                flexGrow: 1
            }
        }
    },
    SignupForm: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1
    },
    Onboarding: {
        width: 300,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',

        '& .form-field-wrapper': {
            flexShrink: 1,

            '& button:first-child': {
                width: '100%'
            },
            '&>div>input:first-child': {
                width: 158,
                backgroundColor: '#f9f9f9'
            },
            '&>div>div>input:first-child': {
                width: 158,
                backgroundColor: '#f9f9f9'
            },
            '& .warning': {
                display: 'none',
            }
        },

        '& .form-field': {
            margin: [10, 0],
            display: 'flex',

            '& label': {
                flexShrink: 0
            }
        },
        '& #Hcaptcha': {
            margin: [10, 0]
        },

        '& form': {
            marginTop: '40px'
        }
    },
    Bar: {
        padding: 20,
        flexGrow: 0,
        flexShrink: 0,
        width:  '100%',
        boxSizing: 'border-box',
    },
    Footer: {
        fontWeight: 500,
        fontFamily: theme[ '$font-default' ],
        fontSize: 12,
        color: theme['$text-color'],
    },
    Logo: {
        verticalAlign: 'top'
    },
    BigLogo: {
        margin: {
            left: 'auto',
            right: 'auto',
            bottom: 50
        },

        '& > img': {
            maxWidth: 300
        }
    },
    Header:  {
        fontFamily: theme['$font-heading'],
        marginBottom: 17,
        color: theme['$text-color'],
        fontSize: 18,
        fontWeight: '700',
        textAlign: 'center',
    },
    ContentPanel: {
        flexShrink: 0,
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        '&>div': {
            flex: 'initial',
        },
    },
    BigError: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%'
    }
});
